module.exports = __webpack_public_path__ + "static/media/shopify.9a64a512.svg";